import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getUsers } from './../../../reducers/users';
import { FormattedMessage } from 'react-intl';
import Modal from './../../modal';
import { ContactForm } from './../../forms';
import messages from '../../../text/messages';

import './users.css';

class UserList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: { open: false }
        };

        // modal controls
        this.onOpen = this.onOpen.bind(this);
        this.onClose = this.onClose.bind(this);
    }

    onOpen() {
        this.setState({ modal: { open: true } });
    }

    onClose() {
        this.setState({ modal: { open: false } });
    }

    componentDidMount() {
        let { role, getUsers } = this.props;
        if (role) {
            getUsers(role);
        }
    }

    render() {
        const { users } = this.props;
        return (
            <div className="row">
                <div className="col-xs-12 address-item" onClick={this.onOpen}>
                    <div className="row">
                        <span className="address-create col-xs-12">
                            <i className="material-icons">add_box</i>
                            <FormattedMessage {...messages.createContact} />
                        </span>
                    </div>
                </div>
                {users.map((user, i) => {
                    return (
                        <div className="col-xs-12 address-item" key={i}>
                            <div className="row">
                                <div className="col-md-6 col-xs-10">
                                    <span className="user-name">
                                        {user.first_name} {user.last_name}
                                    </span>
                                    <span className="user-info">{user.email}</span>
                                </div>
                                <span className="user-info col-md-3 col-xs-4">{user.account_type}</span>
                            </div>
                        </div>
                    );
                })}

                <Modal
                    title={<FormattedMessage {...messages.createContact} />}
                    open={this.state.modal.open}
                    onClose={this.onClose}
                    managedClose
                    size="col-xs-8 col-xs-offset-2"
                >
                    <div className="row">
                        <ContactForm onSubmit={() => console.log('creating contact')} form={'create-contact'} cancel={this.onClose} />
                    </div>
                </Modal>
            </div>
        );
    }
}

UserList.defaultProps = {
    role: undefined,
    users: []
};

UserList.propTypes = {
    role: PropTypes.object,
    users: PropTypes.array
};

const mapStateToProps = state => ({
    users: state.users.list,
    role: state.identity.role
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getUsers: getUsers
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(UserList);



// WEBPACK FOOTER //
// ./src/components/lists/users/index.jsx